export default __webpack_public_path__ + "static/media/weblogoWhite.59e042c7.svg";